import * as yup from 'yup';

export interface FormData {
  travelCountry: string;
  travelDate: string;
  returnDate: string;
  name: string;
  address: string;
  zipCode: string;
  city: string;
  email: string;
  registrationNumber: string;
  policyNumber: string;
}

yup.setLocale({
  mixed: {
    required: 'Dette felt er obligatorisk'
  }
});

export const validationSchema = (formData: FormData) => {
  return yup.object().shape({
    travelCountry: yup.string().required(),
    travelDate: yup.string().required(),
    returnDate: yup.string().required(),
    name: yup.string().required(),
    address: yup.string().required(),
    zipCode: yup.string().required(),
    city: yup.string().required(),
    email: yup
      .string()
      .required()
      .email(`${formData.email} er ikke en gyldig email`),
    registrationNumber: yup.string().required(),
    policyNumber: yup.string().required()
  });
};

export const to = (_body: any) => {
  return 'BestillingGJ@gjensidige.dk';
};

export default validationSchema;
